/* Progressive enhancement: the complete library remains native HTML without JS. */
(() => {
  const normalise = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  function init(root) {
    if (root.dataset.ready) return;
    const input = root.querySelector('[data-kg-guide-search]');
    const filters = [...root.querySelectorAll('[data-kg-guide-filter]')];
    const guides = [...root.querySelectorAll('[data-kg-guide]')];
    const count = root.querySelector('[data-kg-guide-count]');
    const empty = root.querySelector('[data-kg-guide-empty]');
    if (!input || !count || !empty || guides.length !== 6) return;
    root.dataset.ready = 'true';
    let family = 'all';
    // Index the full editorial text and aliases once; user input never becomes HTML.
    const index = new Map(guides.map(guide => [guide, normalise(guide.textContent + ' ' + guide.dataset.keywords)]));
    function apply() {
      const terms = normalise(input.value).split(/\s+/).filter(Boolean);
      let visible = 0;
      for (const guide of guides) {
        const match = (family === 'all' || guide.dataset.family === family) && terms.every(term => index.get(guide).includes(term));
        guide.hidden = !match;
        if (match) visible++;
      }
      for (const button of filters) button.setAttribute('aria-pressed', String(button.dataset.kgGuideFilter === family));
      count.textContent = count.dataset.countTemplate.replace('§', String(visible));
      empty.hidden = visible !== 0;
    }
    input.addEventListener('input', apply);
    for (const button of filters) button.addEventListener('click', () => { family = button.dataset.kgGuideFilter; apply(); });
    root.querySelector('[data-kg-guide-reset]').addEventListener('click', () => { input.value = ''; family = 'all'; apply(); input.focus(); });
    // A direct link always reveals its target, even after filtering; unknown hashes are ignored.
    function revealHash() {
      const guide = guides.find(item => '#' + item.id === window.location.hash);
      if (!guide) return;
      if (guide.hidden) { input.value = ''; family = 'all'; apply(); }
      guide.open = true;
      requestAnimationFrame(() => guide.scrollIntoView({ block: 'start', behavior: 'instant' }));
    }
    window.addEventListener('hashchange', revealHash);
    for (const link of root.querySelectorAll('[data-kg-guide-permalink]')) link.addEventListener('click', () => {
      if (window.location.hash === link.hash) revealHash();
    });
    const water = root.querySelector('[data-kg-water-select]');
    const answers = [...root.querySelectorAll('[data-kg-water-answer]')];
    function showWater() { for (const answer of answers) answer.hidden = answer.dataset.kgWaterAnswer !== water.value; }
    if (water && answers.length) {
      showWater();
      water.addEventListener('change', showWater);
      root.querySelector('[data-kg-water-control]').hidden = false;
    }
    root.querySelector('[data-kg-guide-controls]').hidden = false;
    apply();
    if (window.location.hash) revealHash();
  }
  document.querySelectorAll('[data-kg-guides]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-kg-guides]').forEach(init));
})();
